import * as Api from './Api';
import * as Data from './Data';
import * as Store from './Store';

// Injected by the router.
export interface Routes {
  params: {
    vrid: number;
    prid?: number;
    type?: 'collection' | 'delivery';
    id?: number;
    concessionStoreId?: number;
  };
}

export type RouteRestaurant = Data.Async<
  Api.CollectionRestaurantDetail | Api.DeliveryRestaurantDetail
>;

export const FindRestaurant = (
  state: Store.State,
  route: Routes
): RouteRestaurant => {
  let r:
    | Data.Async<Api.CollectionRestaurantDetail | Api.DeliveryRestaurantDetail>
    | undefined;

  switch (route.params.type) {
    case 'collection':
      r = state.collectionRestaurants[route.params.id];
      break;
    case 'delivery': {
      const key = Store.DeliveryKey(route.params.vrid, route.params.id);
      r = state.deliveryRestaurants[key];
      break;
    }
  }

  if (!r) {
    r = { status: 'none' };
  }

  return r;
};

export const Currency = (restaurant: RouteRestaurant): Api.Currency => {
  switch (restaurant.status) {
    case 'none':
    case 'pending':
      // TODO - this will show euro as the currency until the restaurant is
      // loaded. This would be better added a default currency to AppConfig.
      return Api.Currency.EUR;
    default:
      return restaurant.data.Currency;
  }
};

export const OutsideDeliveryZone = (restaurant: RouteRestaurant) => {
  switch (restaurant.status) {
    case 'pending':
    case 'none':
      return false;
    default:
      return (
        restaurant.data.DeliveryType === Api.DeliveryType.Delivery &&
        restaurant.data.UserOutsideDeliveryZone
      );
  }
};

export const ToUrl = ({ params }: Routes): string => {
  return (
    '/restaurant/' +
    params.vrid +
    '/' +
    params.type +
    '/' +
    params.id +
    (params.concessionStoreId ? '/' + params.concessionStoreId : '')
  );
};
